import { render, staticRenderFns } from "./DesignerSidebar.vue?vue&type=template&id=3fcb3ad0&scoped=true&"
import script from "./DesignerSidebar.vue?vue&type=script&lang=js&"
export * from "./DesignerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DesignerSidebar.vue?vue&type=style&index=0&id=3fcb3ad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcb3ad0",
  null
  
)

export default component.exports